import * as Types from '../../../__generated__/api/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type NotifiersQueryVariables = Types.Exact<{
  path: Types.Scalars['String']['input'];
}>;

export type NotifiersQuery = {
  notifiers: {
    __typename: 'Notifier';
    notification: {
      __typename: 'Notification';
      id: string;
      colorMode: string;
      description: string;
      logo: string | null;
      title: string;
      backgroundImage: string | null;
      buttons: Array<{
        __typename: 'NotificationButton';
        buttonColor: string;
        buttonLink: string;
        buttonText: string;
        buttonType: Types.ButtonActionType;
      }>;
    } | null;
  };
};

export const NotifiersDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'Notifiers' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'path' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'notifiers' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'path' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'path' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'notification' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'colorMode' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'logo' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'backgroundImage' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'buttons' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'buttonColor' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'buttonLink' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'buttonText' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'buttonType' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<NotifiersQuery, NotifiersQueryVariables>;
